import { Divider, Link } from '@heroui/react';
import { useDocumentTitle } from '@hooks/useDocumentTitle';
import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

export function TitleWrapper({ children, title }) {
  useDocumentTitle(`WPC - ${title}`);
  return <>{children}</>;
}

const CustomLink = ({ href, children, ...props }) => {
  const isExternal = /^(https?|webcal|mailto|sms):/.test(href);
  const isPdf = /\.pdf$/.test(href);
  const isCalendar = /\.ics$/.test(href);

  if (isExternal || isPdf) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
        {children}
      </a>
    );
  }

  if (isCalendar) {
    return (
      <a href={`https://windsorparkcommunity.org${href}`} download {...props}>
        {children}
      </a>
    );
  }

  return (
    <Link href={href} {...props} isExternal={isExternal}>
      {children}
    </Link>
  );
};

export function MarkdownWrapper({ children, title, components = {}, className }) {
  components = {
    hr: Divider,
    a: CustomLink,
    ...components,
  };
  return (
    <TitleWrapper title={title}>
      <Markdown className={`md ${className}`} components={components} rehypePlugins={[rehypeRaw]}>
        {children}
      </Markdown>
    </TitleWrapper>
  );
}
